import { useState } from "react";
import { ImageVisualizerElem } from "./ImageVisualizer.styles"
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import { VerticalSpacing } from "../VerticalSpacing";

interface ImageVisualizerProps {
    srcs: string[],
}

export const ImageVisualizer = ({ srcs }: ImageVisualizerProps) => {
    const [open, setOpen] = useState(false);

    return <>
        {
            srcs.map(src => <VerticalSpacing bottom={24} key={src}>
                <ImageVisualizerElem
                    src={src}
                    onClick={() => setOpen(true)}
                />
            </VerticalSpacing>)
        }
        <Lightbox
            open={open}
            close={() => setOpen(false)}
            slides={srcs.map(src => ({ src }))}
            plugins={[Zoom]}
        />
    </>
}